import type { CreateCourseDraft201Instructor } from './createCourseDraft201Instructor';
import type { CreateCourseDraft201Level } from './createCourseDraft201Level';
import type { CreateCourseDraft201Price } from './createCourseDraft201Price';
import type { CreateCourseDraft201SectionsItem } from './createCourseDraft201SectionsItem';

/**
 * 강의 초안 상세 정보 응답
 */
export type CreateCourseDraft201 = {
  createdAt?: string;
  /** @nullable */
  description?: string | null;
  /** 강의 초안 ID */
  id: number;
  /** 기본 사용자 정보 */
  instructor?: CreateCourseDraft201Instructor;
  /** 발행 여부 (초안이므로 항상 false) */
  readonly isPublished?: boolean;
  /** @nullable */
  level?: CreateCourseDraft201Level;
  /** @nullable */
  price?: CreateCourseDraft201Price;
  /**
   * 강의 커리큘럼 섹션 목록 (상세 정보 포함)
   * @nullable
   */
  sections?: CreateCourseDraft201SectionsItem[] | null;
  /** @nullable */
  thumbnailUrl?: string | null;
  title: string;
  updatedAt?: string;
};
